/* navigation
========================================================================== */
const MOBILE_BREAKPOINT = 1024;
const MIN_LOGO_SPACE = {
    sezane: 200,
    octobre: 200,
};
const SHRINKED_CLASS = 'header-is-shrinked';
export default function handleNavigation() {
    const navigationItems = document.querySelectorAll('.js-navigation-item');
    const body = document.body;
    const header = document.querySelector('.js-header');
    navigationItems.forEach((navigationItem) => {
        navigationItem.addEventListener('mouseover', () => {
            header.classList.add('is-expanded');
        });
        navigationItem.addEventListener('mouseout', () => {
            header.classList.remove('is-expanded');
        });
    });
    const nav = document.querySelector('.js-nav-submenu');
    const icons = document.querySelector('.js-header-icons');
    const headerDefault = document.querySelector('.js-header-default');
    const headerInner = document.querySelector('.c-header__inner');
    const host = window.location.host;
    const brand = host.includes('sezane') ? 'sezane' : 'octobre';
    const headerDefaultResize = new ResizeObserver(() => {
        const headerHeight = header.offsetHeight;
        const headerHeightProperty = getComputedStyle(header).getPropertyValue('--header-dynamic-height');
        if (headerHeight !== parseInt(headerHeightProperty, 10)) {
            header.style.setProperty('--header-dynamic-height', `${headerHeight}px`);
        }
        const spaceForLogo = headerInner.offsetWidth - nav.offsetWidth - icons.offsetWidth;
        const hasShrinkedClass = body.classList.contains(SHRINKED_CLASS);
        if (window.innerWidth > MOBILE_BREAKPOINT) {
            if (spaceForLogo >= MIN_LOGO_SPACE[brand]) {
                hasShrinkedClass && body.classList.remove(SHRINKED_CLASS);
            }
            else {
                !hasShrinkedClass && body.classList.add(SHRINKED_CLASS);
            }
        }
        else {
            hasShrinkedClass && body.classList.remove(SHRINKED_CLASS);
        }
    });
    if (headerDefault) {
        headerDefaultResize.observe(headerDefault);
    }
}
